import {Routes} from '@angular/router';
import {ProfessionalReferenceScreensManager} from './steps/professional/professional-reference-screens-manager.service';
import {ReferencesPageComponent} from './references-page.component';
import {ProfessionalReferenceScreenComponent} from './steps/professional/professional-reference-screen.component';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
const routes: Routes = [{
    path: 'professionalReference',
    component: ReferencesPageComponent,
    children: [
        {path: '', redirectTo: '1', pathMatch: 'full'},
        {
            path: ':index',
            component: ProfessionalReferenceScreenComponent,
            data: {step: {screensManager: ProfessionalReferenceScreensManager}}
        }
    ],
    data: {section: {title: 'Professional References'}, impersonationAllowed: true}
}];
export default routes;

export const screenManagers = [ProfessionalReferenceScreensManager];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/references/references-page.routing.ts